module.exports = __webpack_public_path__ + "img/Bedroom.ae6950a1.jpg";